export const SET_CURRENT_APPOINTMENT = 'SET_CURRENT_APPOINTMENT';
export const REMOVE_CURRENT_APPOINTMENT = 'REMOVE_CURRENT_APPOINTMENT';
export const SET_ALL_APPOINTMENTS ='SET_ALL_APPOINTMENTS';